<template>
  <div class="container">
    <p ref="triggerTitle" class="title" @click="toggleDropdown">{{ time }}{{ title }}</p>
    <div v-show="showSelect" class="select">
      <p class="select-item" @click="handleSelect(0)">海外事业部运营报表</p>
      <p class="select-item" @click="handleSelect(1)">汇嘉信运营报表</p>
    </div>
    <div class="warp">
      <div class="tabs">
        <div
          class="tab"
          :class="{ active: isActive === 0 }"
          @click="handleTabChange(0)"
        >
          系统客户制单数据统计
        </div>
        <div
          class="tab"
          :class="{ active: isActive === 1 }"
          @click="handleTabChange(1)"
        >
          系统账号制单数据统计
        </div>
        <div
          class="tab"
          :class="{ active: isActive === 2 }"
          @click="handleTabChange(2)"
        >
          空运提单情况汇总
        </div>
        <div
          class="tab"
          :class="{ active: isActive === 3 }"
          @click="handleTabChange(3)"
        >
          海运提单情况汇总
        </div>
        <div
          class="tab"
          :class="{ active: isActive === 4 }"
          @click="handleTabChange(4)"
        >
          当月营收情况统计
        </div>
      </div>
    </div>
    <div class="data sumData">
      <BaseTable
        id="baseTable"
        :height="640"
        :tableData="{
          fileds,
          columns,
        }"
        :isPager="false"
        :headerCellStyle="{
          'font-size': '14px',
          color: '#FFFFFF',
          background: ' rgb(18,88,188)',
        }"
        :show-summary="true"
        :getSummaries="getSummaries"
      ></BaseTable>
    </div>
  </div>
</template>
<script>
import { getOperationsReport } from '@/api/system'
const BaseTable = () => import('@/components/table/BaseTable')
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
export default {
  components: { BaseTable },
  data() {
    return {
      isActive: 0,
      tableData: {
        fileds: [],
        columns: []
      },
      companyOrderReports: [],
      accountOrderReports: [],
      airMBLReports: [],
      seaMBLReports: [],
      operationsReport: {},
      time: '',
      title: '海外事业部运营报表',
      showSelect: false,
      timestamp: '',
      checkCode: '',
      timestampNow: '',
      type: ''
    }
  },
  computed: {
    ...mapGetters(['databoard']),
    fileds() {
      const obj = {
        0: [
          {
            filed: 'companyName',
            label: '中文品名',
            width: '300',
            align: 'left'
          },
          {
            filed: 'orderWeight',
            label: '制单重量(T)',
            width: '300',
            align: 'right'
          },
          {
            filed: 'orderQty',
            label: '制单票数',
            width: '300',
            align: 'right'
          },
          {
            filed: 'systemFreight',
            label: '系统运费(USD)',
            width: '300',
            align: 'right'
          }
        ],
        1: [
          {
            filed: 'accountNumber',
            label: '制单账号',
            width: '300',
            align: 'left'
          },
          {
            filed: 'orderWeight',
            label: '制单重量(T)',
            width: '300',
            align: 'right'
          },
          {
            filed: 'orderQty',
            label: '制单票数',
            width: '300',
            align: 'right'
          },
          {
            filed: 'systemFreight',
            label: '系统运费(USD)',
            width: '300',
            align: 'right'
          }
        ],
        2: [
          {
            filed: 'companyName',
            label: '所属客户',
            width: '300',
            align: 'left'
          },
          {
            filed: 'newQty',
            label: '新增提单数量',
            width: '225',
            align: 'right'
          },
          {
            filed: 'releasedQty',
            label: '清关放行提单数量',
            width: '225',
            align: 'right'
          },
          {
            filed: 'pickUpQty',
            label: '提货提单数量',
            width: '225',
            align: 'right'
          },
          {
            filed: 'departruedQty',
            label: '出仓提单数量',
            width: '225',
            align: 'right'
          }
        ],
        3: [
          {
            filed: 'companyName',
            label: '所属客户',
            width: '300',
            align: 'left'
          },
          {
            filed: 'newQty',
            label: '新增提单数量',
            width: '225',
            align: 'right'
          },
          {
            filed: 'releasedQty',
            label: '清关放行提单数量',
            width: '225',
            align: 'right'
          },
          {
            filed: 'pickUpQty',
            label: '提货提单数量',
            width: '225',
            align: 'right'
          },
          {
            filed: 'departruedQty',
            label: '出仓提单数量',
            width: '225',
            align: 'right'
          }
        ],
        4: [
          {
            filed: 'companyName',
            label: '所属客户',
            width: '300',
            align: 'left'
          },
          {
            filed: 'receivableFee',
            label: '系统应收录入费用(USD)',
            width: '225',
            align: 'right'
          },
          {
            filed: 'orderFee',
            label: '系统制单运费统计(USD)',
            width: '225',
            align: 'right'
          },
          {
            filed: 'rateAdjustment',
            label: '调整费用统计(USD)',
            width: '225',
            align: 'right'
          },
          {
            filed: 'monthTotalRevenue',
            label: '当月总营收(USD)',
            width: '225',
            align: 'right'
          }
        ]
      }
      return obj[this.isActive]
    },
    columns() {
      let columns
    //   if (this.$route.query.timestamp) {
        switch (this.isActive) {
          case 0:
            columns = this.companyOrderReports
            break
          case 1:
            columns = this.accountOrderReports
            break
          case 2:
            columns = this.airMBLReports
            break
          case 3:
            columns = this.seaMBLReports
            break
          case 4:
            columns = this.operationsReport.companyOperationsReports
            break
        }
    //   } else {
    //     switch (this.isActive) {
    //       case 0:
    //         columns = this.databoard?.companyOrderReports
    //         break
    //       case 1:
    //         columns = this.databoard?.accountOrderReports
    //         break
    //       case 2:
    //         columns = this.databoard?.airMBLReports
    //         break
    //       case 3:
    //         columns = this.databoard?.seaMBLReports
    //         break
    //       case 4:
    //         columns = this.databoard?.operationsReport.companyOperationsReports
    //         break
    //     }
    //   }
    //   console.log('columns', columns)
      return columns
    }
  },
  watch: {
    databoard: {
      handler(val) {
        if (val) {
          this.companyOrderReports = val.companyOrderReports
          this.accountOrderReports = val.accountOrderReports
          this.airMBLReports = val.airMBLReports
          this.seaMBLReports = val.seaMBLReports
          this.operationsReport = val.operationsReport
        }
      },
      immediate: true
    }
  },
  created() {},
  mounted() {
    this.timestamp = this.$route.query.timestamp
    this.checkCode = this.$route.query.checkCode
    this.timestampNow = this.$route.query.timestampNow
    this.type = this.$route.query.type
    if (this.checkCode && this.timestamp && this.timestampNow && this.type) {
      this.time = dayjs.unix(this.timestamp).format('YYYY-MM-DD')
      this.getData(this.timestamp, this.checkCode, this.timestampNow, this.type)
    } else {
      this.$nextTick(() => {
        this.renderSum()
      })
      if (this.$route.query.type === 0) {
        this.title = '海外事业部运营报表'
      } else if (this.$route.query.type === 1) {
        this.title = '汇嘉信运营报表'
      }
      // setTimeout(() => {
      //   this.renderSum()
      // }, 0)
    }
  },
  methods: {
    async getData(timestamp, checkCode, timestampNow, type) {
      try {
        const res = await getOperationsReport({
          timestamp,
          checkCode,
          timestampNow,
          type
        })
        if (res.success) {
          this.companyOrderReports = res.data.companyOrderReports
          this.accountOrderReports = res.data.accountOrderReports
          this.airMBLReports = res.data.airMBLReports
          this.seaMBLReports = res.data.seaMBLReports
          this.operationsReport = res.data.operationsReport
          this.$nextTick(() => {
            this.renderSum()
          })
        } else {
          this.$message.error(res.errorMessage)
        }
        console.log('res', res)
      } catch (error) {
        console.log(error)
      }
    },
    handleTabChange(index) {
      if (index !== this.isActive) {
        this.isActive = index
      }
      this.$nextTick(() => {
        this.renderSum()
      })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '汇总'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value))) {
          sums[index] = (
            values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0) || 0
          ).toFixed(2)
        }
      })
      return sums
    },
    renderSum() {
      const tdf = document.querySelectorAll(
        '#baseTable .el-table__footer-wrapper tbody'
      )
      if (!tdf[0]) {
        return false
      }
      tdf[0].innerHTML = ''
      let html = ''
      if (this.isActive < 2) {
        const data = this.isActive ? this.companyOrderReports : this.accountOrderReports
        let orderWeight = 0
        let orderQty = 0
        let systemFreight = 0
        data.forEach((a) => {
          orderWeight += +a.orderWeight
          orderQty += +a.orderQty
          systemFreight += +a.systemFreight
        })
        html += `<tr>
                <td colspan="1" rowspan="1" class="is-left is-leaf el-table__cell">
                    <div class="cell">汇总</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${orderWeight.toFixed(2)}</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${orderQty.toFixed(2)}</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${systemFreight.toFixed(2)}</div>
                </td>
            </tr>`
      } else if (this.isActive < 4) {
        const data =
          this.isActive === 2
            ? this.airMBLReports
            : this.seaMBLReports
        let newQty = 0
        let releasedQty = 0
        let pickUpQty = 0
        let departruedQty = 0
        data.forEach((a) => {
          newQty += +a.newQty
          releasedQty += +a.releasedQty
          pickUpQty += +a.pickUpQty
          departruedQty += +a.departruedQty
        })
        html += `<tr>
                <td colspan="1" rowspan="1" class="is-left is-leaf el-table__cell">
                    <div class="cell">汇总</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${newQty.toFixed(2)}</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${releasedQty.toFixed(2)}</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${pickUpQty.toFixed(2)}</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${departruedQty.toFixed(2)}</div>
                </td>
            </tr>`
      } else {
        let receivableFee = 0
        let orderFee = 0
        let rateAdjustment = 0
        let monthTotalRevenue = 0
        this.operationsReport.companyOperationsReports.forEach((a) => {
            receivableFee += +a.receivableFee
            orderFee += +a.orderFee
            rateAdjustment += +a.rateAdjustment
            monthTotalRevenue += +a.monthTotalRevenue
        })
        html += `<tr>
                <td colspan="1" rowspan="1" class=" is-left is-leaf el-table__cell">
                    <div class="cell">汇总</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${receivableFee.toFixed(2)}</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${orderFee.toFixed(2)}</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${rateAdjustment.toFixed(2)}</div>
                </td>
                <td colspan="1" rowspan="1" class="is-right is-leaf el-table__cell">
                    <div class="cell">${monthTotalRevenue.toFixed(2)}</div>
                </td>
            </tr>
            <tr>
                <td colspan="4" rowspan="1" class=" is-right is-leaf el-table__cell">
                    <div class="cell">本月合计(不含汇嘉信/上海/小包B2C数据)</div>
                </td>
                <td colspan="1" rowspan="1" class=" is-right is-leaf t el-table__cell">
                    <div class="cell">${(
                      this.operationsReport.thisMonthTotal || 0
                    ).toFixed(2)}</div>
                </td>
            </tr>
            <tr>
                <td colspan="4" rowspan="1" class=" is-right is-leaf el-table__cell">
                    <div class="cell">本月实收</div>
                </td>
                <td colspan="1" rowspan="1" class=" is-right is-leaf  el-table__cell">
                    <div class="cell">${(
                      this.operationsReport.thisMonthReceivable || 0
                    ).toFixed(2)}</div>
                </td>
            </tr>
            <tr>
                <td colspan="4" rowspan="1" class=" is-right is-leaf el-table__cell">
                    <div class="cell">本月支出</div>
                </td>
                <td colspan="1" rowspan="1" class=" is-right is-leaf el-table__cell">
                    <div class="cell">${(
                      this.operationsReport.thisMonthPay || 0
                    ).toFixed(2)}</div>
                </td>
            </tr>
            <tr>
                <td colspan="4" rowspan="1" class=" is-right is-leaf el-table__cell">
                    <div class="cell">现金流</div>
                </td>
                <td colspan="1" rowspan="1" class=" is-right is-leaf el-table__cell">
                    <div class="cell">${(
                      this.operationsReport.cashFlow || 0
                    ).toFixed(2)}</div>
                </td>
            </tr>`
      }
      tdf[0].innerHTML = html
    },
    handleSelect(type) {
      this.showSelect = false
      if (!type) {
        this.title = '海外事业部运营报表'
        this.getData(this.timestamp, this.checkCode, this.timestampNow, type)
        this.type = type
      } else if (type) {
        this.title = '汇嘉信运营报表'
        this.getData(this.timestamp, this.checkCode, this.timestampNow, type)
        this.type = type
      }
    },
    toggleDropdown() {
      this.showSelect = !this.showSelect
      if (this.showSelect) {
        document.addEventListener('click', this.hideDropdown)
      } else {
        document.removeEventListener('click', this.hideDropdown)
      }
    },
    hideDropdown(event) {
      const targetElement = event.target
      const dropdownContainer = this.$refs.triggerTitle
      if (!dropdownContainer || !dropdownContainer.contains(targetElement)) {
        this.showSelect = false
        document.removeEventListener('click', this.hideDropdown)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  background: #f1f8fd;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  overflow: hidden;
  position: relative;
  .title {
    width: 100%;
    max-width: 500px;
    margin: 30px auto;
    height: 60px;
    font-size: 28px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 60px;
    text-align: center;
    border-bottom: 2px solid #2882DC;
    position: relative;
    cursor: pointer;
    &::after {
      content: ' ';
      position: absolute;
      width: 0;
      height: 0;
      border-top: 8px solid #2882DC;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      right: 10px;
      top: 30px;
    }
  }
  .select {
    position: absolute;
    width: 100%;
    max-width: 500px;
    color: #000000;
    line-height: 40px;
    background: #fff;
    z-index: 999;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
    top: 92px;
    p {
      border: 1px solid #fcfcfc;
      cursor: pointer;
      font-size: 14px;
    }
    p:hover {
      color: #2882DC;
    }
  }
  .tabs {
    margin: 0 auto;
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    .tab {
      width: 200px;
      height: 40px;
      background: #ffffff;
      border-radius: 5px 5px 5px 5px;
      opacity: 1;
      font-size: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      border: 1px solid #dcdfe6;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      & + .tab {
        margin-left: 10px;
      }
    }
    .active {
      color: #409eff;
      font-weight: bold;
      border: 1px solid #409eff;
      position: relative;
      &::before {
        content: " ";
        position: absolute;
        width: 0;
        height: 0;
        border-top: 5px solid #ffffff;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        left: 50%;
        bottom: -4px;
        margin-left: -7.5px;
        z-index: 1;
      }
      &::after {
        content: " ";
        position: absolute;
        width: 0;
        height: 0;
        border-top: 5px solid #409eff;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        left: 50%;
        bottom: -5px;
        margin-left: -7.5px;
      }
    }
  }
  .data {
    width: 1200px;
    height: 640px;
    margin: 20px auto 0;
    &:deep(.el-table__footer-wrapper
        tbody
        td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell) {
      font-weight: bold;
      font-size: 14px;
      color: #ff4b4b;
      background: #fff2ec;
    }
  }
  .sum-row {
    width: calc(100% - 2px);
    height: 40px;
    background: #fff2ec;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #dcdfe6;
    border-top: 0;
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    color: #ff4b4b;
    line-height: 40px;
    text-align: right;
    .cell {
      width: calc(80% - 21px);
      padding: 0 10px;
      border-right: 1px solid #dcdfe6;
    }
    .value {
      width: calc(20% - 20px);
      padding: 0 10px;
      text-align: right;
    }
  }
  @media screen and (max-width: 1366px) {
    .title {
      height: 24px;
      font-size: 18px;
      font-weight: 400;
      color: #000000;
      line-height: 24px;
      padding: 15px 0;
    }
    .warp {
        contain: paint;
    }
    .tabs {
      width: calc(100% - 10px);
      height: 40px;
      justify-content: flex-start;
      padding: 0 5px 16px;
      overflow-y: hidden;
      overflow-x: auto;
      margin-bottom: -10px;
      .tab {
        width: 140px;
        min-width: 140px;
        font-size: 12px;
      }
    }
    .data {
      width: 100%;
    }
  }
}
</style>
